import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DialogsConfigService {
  onCustomClick$ = new Subject<any>();

  constructor() {}

  public SubmitButton(text = 'Save') {
    return {
      submit: {
        text: text,
      },
    };
  }

  public CancelButton(text = 'Cancel') {
    return {
      cancel: {
        text: text,
      },
    };
  }

  public DismissButton(text = 'Cancel') {
    return {
      dismiss: {
        text: text,
      },
    };
  }

  public DangerButton(text = 'Danger') {
    return {
      danger: {
        text: text,
      },
    };
  }

  public DenyButton(text = 'Deny') {
    return {
      deny: {
        text: text,
      },
    };
  }

  public CustomButton(text = 'My button', preventClose = false) {
    return {
      custom: {
        text: text,
        customCallback: () => void 0,
        preventClose: preventClose,
      },
    };
  }

  public CustomButtonSub(text = 'My button') {
    return {
      customSub: {
        text: text,
        subject: this.onCustomClick$,
      },
    };
  }

  public SubmitDismissButtons(submitText?, dismissText?) {
    return {
      ...this.SubmitButton(submitText),
      ...this.DismissButton(dismissText),
    };
  }

  public SubmitDenyButtons(submitText?, denyText?) {
    return {
      ...this.SubmitButton(submitText),
      ...this.DenyButton(denyText),
    };
  }

  public SubmitDismissCutomButtons(submitText?: string, dismissText?: string, customText?: string) {
    return {
      ...this.SubmitButton(submitText),
      ...this.DismissButton(dismissText),
      ...this.CustomButton(customText),
    };
  }

  public SubmitDismissCustomSubButtons(
    submitText?: string,
    dismissText?: string,
    customText?: string,
  ) {
    return {
      ...this.SubmitButton(submitText),
      ...this.DismissButton(dismissText),
      ...this.CustomButtonSub(customText),
    };
  }

  public DismissCustomButtons(
    dismissText?: string,
    customText?: string,
    preventClose: boolean = false,
  ) {
    return {
      ...this.DismissButton(dismissText),
      ...this.CustomButton(customText, preventClose),
    };
  }

  public SubmitCustomButtons(submitText?: string, customText?: string) {
    return {
      ...this.SubmitButton(submitText),
      ...this.CustomButton(customText),
    };
  }
}
